import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


// Import Styles
// import '../styles/components/data-samples-table.scss';



const SamplesTable = (props) => {
  // const { items, requestSort, sortConfig } = useSortableData(props.samples);
  // const getClassNamesFor = (name) => {
  //   if (!sortConfig) {
  //     return;
  //   }
  //   return sortConfig.key === name ? sortConfig.direction : undefined;
  // };




  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [rowClick, setRowClick] = useState(true);

  const columns = [
      {field: 'sample', header: 'Sample'},
      {field: 'date',   header: 'Date'},
      {field: 'file1',  header: 'File 1'},
      {field: 'file2',  header: 'File 2'},
      {field: 'longitude', header: 'Longitude'},
      {field: 'latitude',   header: 'Latitude'},
      {field: 'origin',  header: 'Origin'},
      {field: 'transmissionRate',  header: 'Transmission Rate'}
  ];

  useEffect(() => {
      // ProductService.getProductsMini().then(data => setProducts(data));
      props.samples.map(data => setProducts(data));
  }, []);

    return (

      <div className=''>
        {/* <DataTable value={props.samples} tableStyle={{ minWidth: '50rem' }}> */}
        <DataTable 
          value={props.samples} 
          selectionMode={rowClick ? null : 'checkbox'} 
          selection={selectedProducts} 
          onSelectionChange={(e) => setSelectedProducts(e.value)} 
          dataKey="id" 
          // scrollable scrollHeight="800px"
          paginator rows={10} rowsPerPageOptions={[10, 25, 50, 100]}
          tableStyle={{ minWidth: '50rem' }}
        >
          {/* <Column key='selector' body='🔲' />
          <Column key='actions' body='⠇' header='Actions' /> */}

          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
          {columns.map((col, i) => (
            <Column key={col.field} field={col.field} header={col.header} sortable />
          ))}
        </DataTable>
      </div>
    );
  }

  export default SamplesTable;